import {
  EDIT_CLIENT_ALLOCATION,
  EDIT_CRISIS_ALLOCATION,
  EDIT_MY_CLIENT_ALLOCATION,
  VIEW_CLIENT_ALLOCATION,
  VIEW_CRISIS_ALLOCATION,
  VIEW_MY_CLIENT_ALLOCATION,
} from '~/ui/constants/paths';

export const getViewAllocationPath = (isCrisis: boolean, isGlobalUser?: boolean): string => {
  if (isGlobalUser) {
    return VIEW_MY_CLIENT_ALLOCATION;
  }

  if (isCrisis) {
    return VIEW_CRISIS_ALLOCATION;
  }

  return VIEW_CLIENT_ALLOCATION;
};

export const getEditAllocationPath = (isCrisis: boolean, isGlobalUser?: boolean): string => {
  if (isGlobalUser) {
    return EDIT_MY_CLIENT_ALLOCATION;
  }

  if (isCrisis) {
    return EDIT_CRISIS_ALLOCATION;
  }

  return EDIT_CLIENT_ALLOCATION;
};
